import React, { useState, useReducer, useEffect } from 'react';
import {
  Paper,
  Chip,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Dialog,
  Tooltip,
} from '@mui/material';
import {
  Link,
  Link as RouterLink,
} from 'react-router-dom';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import TimeAgo from 'react-timeago'

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import EcuHistoryTable, {EcuCalibDialog} from './EcuHistoryTable';
// GeoFormatter per bandierina stile ServiceUserListTableProps
import axios from 'axios';
import { Box } from '@mui/material';
import { GeoSimpleTypeProvider } from './ServiceUserListTableProps';

// ************************************************************
// ************************************************************
// ************************************************************

const VIRTUAL_PAGE_SIZE = 50;

// ************************************************************
// ************************************************************
// ************************************************************

// ************************************************************
// FORMATTER COMPONENTS
// ************************************************************

const UidFlagsFormatter = ({ value }) => {
  if (value != "00000000") return <Chip label={value} size="small" color="error" />  
  return <Chip label={value} size="small" variant="outlined" />  
}
const UidFlagsTypeProvider = props => <DataTypeProvider formatterComponent={UidFlagsFormatter} {...props} />
const RowNumFormatter = ({ value }) => {
  return (
    <>
      <Chip label={value} size="small" variant="outlined" /> 
    </>
  )
}
const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const ProdDateFormatter = ({ row }) => {
  const data = new Date(row.prod_date)
  const opzioniFormattazione = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }
  const formatoItaliano = new Intl.DateTimeFormat('it-IT', opzioniFormattazione)
  const dataFormattata = formatoItaliano.format(data)     
  return (
    <>
      {dataFormattata}
    </>
  )
}
const ProdDateTypeProvider = props => <DataTypeProvider formatterComponent={ProdDateFormatter} {...props} />

const DateFormatter = ({ value }) => {
  value = (!value || value === undefined) ? '0000-00-00 00:00:00' : value.trim()
  if (value === "0000-00-00 00:00:00") return <></>
  return (
    <b style={{ color: 'darkblue' }}>    
      <TimeAgo date={value} />
    </b>
  )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const InstallUserFormatter = ({ row }) => {
  const name0 = row.first_update_username;
  const time0 = row.first_update_date;
  if (time0 === undefined) return <></>
  return <Link to={"/service/user/details/" + row.first_update_user_id}>{row.first_update_username}</Link>
}
const InstallUserTypeProvider = props => <DataTypeProvider formatterComponent={InstallUserFormatter} {...props} />

const LastUpdateUserFormatter = ({ row }) => {
  const name0 = row.first_update_username;
  const name1 = row.last_update_username;
  const highlight = name0 !== name1;
  return (
    <Link
      to={"/service/user/details/" + row.last_update_user_id}
      style={highlight ? { fontWeight: 'bold', color: 'red' } : {}}
    >
      {row.last_update_username}
    </Link>
  );}
const LastUpdateUserTypeProvider = props => <DataTypeProvider formatterComponent={LastUpdateUserFormatter} {...props} />

const CalInfoFormatter = ({ row }) => {
    return (
      <>
        <div>
          { row.calibration_name }
        </div>
        {row.system_type && (<div>
          <Chip 
            size="small" 
            variant="outlined" 
            label={row.system_type} />
        </div>)}
      </>
    ) 
}
const CalInfoTypeProvider = props => <DataTypeProvider formatterComponent={CalInfoFormatter} {...props} />

// ************************************************************
// ************************************************************
// ************************************************************

function EcuIdDialog(props) {
  const [scroll, set_scroll] = React.useState('paper');
  const [first, set_first] = React.useState(true);
  const [loaded, set_loaded] = React.useState(false);
  const [ecu_history, set_ecu_history] = React.useState(null);
  const [ecu_uid, set_ecu_uid] = React.useState("");
  const [prod_date, set_prod_date] = React.useState("");
  const handleRefresh = () => { 
    set_ecu_history(null)
    set_ecu_uid("")
    set_loaded(false)
    AuthService.getEcuHistory(props.ecu_id).then(data => { 
      var temp = utils.ecuHistoryFixer(data.rows)
      set_ecu_history(temp)
      set_ecu_uid(data.uid_value)
      set_loaded(true)
    }) 
  }
  const handleClose = () => { props.onClickClose(); }  
  
  //useEffect(() => {
    if (first && props.open) {
      set_first(false)
      AuthService.getEcuHistory(props.ecu_id).then(data => { 
        var temp = utils.ecuHistoryFixer(data.rows)          
        set_ecu_history(temp)
        set_ecu_uid(data.uid_value)
        set_loaded(true)
      })
      AuthService.getEcuProdDate(props.ecu_id).then(data => { 
        set_prod_date(data.value)
      })
    }
  //}, []);
  
  return (    
    <div>      
      <Dialog
        open={props.open} 
        onClose={handleClose}
        scroll={scroll}
        fullWidth={true}
        maxWidth="xl"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        {/* <DialogTitle id="scroll-dialog-title">ECU ID {props.ecu_id}</DialogTitle> */}
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}>
            <EcuHistoryTable 
              prod_date={prod_date}
              ecu_id={props.ecu_id} 
              ecu_uid={ecu_uid} 
              ecu_history={ecu_history} 
              />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            disabled={!loaded}
            onClick={handleRefresh}>REFRESH</Button>
          <Button onClick={handleClose}>CLOSE</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const EcuIdFormatter = ({ row }) => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => { setOpen(true); }
  const handleClose = () => { setOpen(false); }
  return (
    <> 
      <EcuIdDialog 
        open={open} 
        ecu_id={row.id}
        onClickClose={handleClose} />
      <Tooltip title="SHOW ECU" placement="top" arrow>            
      <Chip 
        label={row.id} 
        color="primary" 
        clickable
        onClick={handleOpen} />
      </Tooltip>
    </>
  )
} 
const CalibIdFormatter = ({ row }) => {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => { setOpen(true); }
  const handleClose = () => { setOpen(false); }
  if (row.last_update_calib_id == undefined) {
    return (<></>)
  }
  return (
    <>
    <EcuCalibDialog 
      calib_id={row.last_update_calib_id} 
      open={open} 
      onClickClose={handleClose} />
    <Tooltip title="SHOW CAL" placement="top" arrow>            
    <Chip 
      label={row.last_update_calib_id} 
      color="primary" 
      clickable
      // target="_blank"
      // rel="noopener noreferrer"
      // component={RouterLink} to={"/ecu/calib/"+row.last_update_calib_id} 
      onClick={handleOpen}
      />
    </Tooltip>            
    </>
  )
} 

// ************************************************************
// TABLE COLUMN/STATE HELPERS
// ************************************************************

const tableColumns = [
  { name: 'row_num', title: '#', getCellValue: row => row.row_num },
  { name: 'id', title: 'ECU ID', getCellValue: row => row.id },
  { name: 'vin', title: 'VIN', getCellValue: row => row.vin },
  { name: 'total_petrol_time', title: 'P. [h]', getCellValue: row => row.total_petrol_time },
  { name: 'total_gas_time', title: 'G. [h]', getCellValue: row => row.total_gas_time },
  //{ name: 'prod_date', title: 'Prod Date', getCellValue: row => row.prod_date },
  { name: 'first_update_date', title: 'Install Date', getCellValue: row => row.first_update_date },
  { name: 'first_update_username', title: 'Install User', getCellValue: row => row.first_update_username },
  { name: 'last_update_date', title: 'Last Update',   getCellValue: row => row.last_update_date },
  { name: 'last_update_username', title: 'Last User',     getCellValue: row => row.last_update_username },
  { name: 'user_location', title: 'Last Geo', getCellValue: row => row.user_location },
  { name: 'last_update_calib_id', title: 'CAL ID', getCellValue: row => row.last_update_calib_id },
  { name: 'calibration_name', title: 'CAL INFO', getCellValue: row => row.calibration_name },
  { name: 'last_version', title: 'FW', getCellValue: row => row.last_version },
]

const tableColumnWidths = [
  { columnName: 'row_num', width: 120 },
  { columnName: 'id', width: 120 },
  { columnName: 'vin', width: 150 },
  { columnName: 'total_petrol_time', width: 80 },
  { columnName: 'total_gas_time', width: 80 },
  //{ columnName: 'prod_date', width: 175 },
  { columnName: 'first_update_date', width: 155 },
  { columnName: 'first_update_username', width: 165 },
  { columnName: 'last_update_date', width: 155 },
  { columnName: 'last_update_username', width: 165 },
  { columnName: 'user_location', width: 120 },
  { columnName: 'last_update_calib_id', width: 120 },
  { columnName: 'calibration_name', width: 280 },
  { columnName: 'last_version', width: 185 },
]

const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'id', align: 'right' },
  { columnName: 'total_petrol_time', align: 'right' },
  { columnName: 'total_gas_time', align: 'right' },
  { columnName: 'last_update_calib_id', align: 'right' },
  { columnName: 'first_update_date', align: 'right' },
  { columnName: 'last_update_date', align: 'right' },
  { columnName: 'user_location', align: 'left' },
]

const tableSortingStateColumnExtensions = [
  { columnName: 'row_num', sortingEnabled: false },
  { columnName: 'user_location', sortingEnabled: false },
]

const tableFilteringStateColumnExtensions = [
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'user_location', filteringEnabled: false },
  { columnName: 'total_petrol_time', filteringEnabled: false },
  { columnName: 'total_gas_time', filteringEnabled: false },
  //{ columnName: 'prod_date', filteringEnabled: false },
  { columnName: 'first_update_date', filteringEnabled: false },
  { columnName: 'last_update_date', filteringEnabled: false },
]

// ************************************************************
// DATA FETCHING METHODS
// ************************************************************

// decodeBase64ToUtf8 resta fuori dalla classe
const decodeBase64ToUtf8 = (base64String) => {
  try {
    return decodeURIComponent(
      escape(window.atob(base64String))
    );
  } catch (e) {
    console.error("Errore durante la decodifica Base64: ", e);
    return '';
  }
};

// Sposta i metodi come metodi della classe EcuList
export default class EcuList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tableRows: [],
      tableSkip: 0,
      requestedTableSkip: 0,
      tableTotalRowCount: VIRTUAL_PAGE_SIZE * 2,
      tableLoading: false,
      tableColumnWidths: this.getTableColumnWidths(),
      tableFilters: [],
      tableSorting: [{
        columnName: "last_update_date",
        direction: "desc",
      }],      
    }
    // Variabili per i timeout
    this.filterTimeout = null;
    this.rowsTimeout = null;
    this.debouncedGetTableRows = this.debouncedGetTableRows.bind(this);
  }

  // Funzione debounce per getTableRows
  debouncedGetTableRows(requestedTableSkip, take) {
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
    this.rowsTimeout = setTimeout(() => {
      this.getTableRows(requestedTableSkip, take);
    }, 800);
  }

  getTableColumns() {
    return [
      ...tableColumns
    ]
  }
  getTableColumnWidths() {
    return [
      ...tableColumnWidths
    ]
  }
  getTableColumnExtensions() {
    return [
      ...tableColumnExtensions
    ]
  }
  getTableSortingStateColumnExtensions() {
    return tableSortingStateColumnExtensions
  }
  getTableFilteringStateColumnExtensions() {
    return tableFilteringStateColumnExtensions
  }
  componentDidMount() {
    AuthService.getEcuCount(this.state.tableFilters).then(data => {
      if (data.is_valid) {
        this.setState({
          tableTotalRowCount: data.value,
        })
      } else {
        //console.log(data.message)
      }
    }).catch(e => {
      //console.log(e)
    })
  }
  async getTableRows(requestedTableSkip, take) {
    this.setState({ 
      requestedTableSkip: requestedTableSkip,
      tableLoading: true
    })
    AuthService.getEcuList(requestedTableSkip, take, this.state.tableSorting[0], this.state.tableFilters).then(data => {
      var i = requestedTableSkip + 1
      data.rows = data.rows.map(row => {
        row.row_num = i++
        return row
      })
      if (data.is_valid) {
        this.setState({
          tableSkip: data.skip, 
          tableRows: data.rows,
          tableLoading: false,
        })
      } else {
        this.setState({ tableLoading: false })
      }
    }).catch(e => {
      this.setState({ tableLoading: false })
    })
  }
  async setTableFilters(value) {
    await this.setState({
      tableFilters: value
    })    
    // Debounce per il conteggio
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    this.filterTimeout = setTimeout(() => {
      AuthService.getEcuCount(this.state.tableFilters).then(data => {
        if (data.is_valid) {
          this.setState({
            tableTotalRowCount: data.value,
          })
        }
      }).catch(e => {})
    }, 800);
    // Debounce anche per la query dei dati
    this.debouncedGetTableRows(0, VIRTUAL_PAGE_SIZE);
  }
  componentWillUnmount() {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
  }
  render() {     
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    if (!utils.userHasRoleAdmin(this.props.authStatus.user)) return <UserAuthRequired notallowed />

    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>
        <Grid 
          rows={this.state.tableRows}
          columns={this.getTableColumns()}
          getRowId={row => row.row_num} // row_num è sempre unico nella tabella visibile
        >

          <DataTypeProvider  
            for={[ "last_update_calib_id" ]}
            formatterComponent={props => <CalibIdFormatter {...{ ...props }} />} 
            availableFilterOperations={[
              'equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'
            ]}
          />  
          <DataTypeProvider  
            for={[ "id" ]}
            formatterComponent={props => <EcuIdFormatter {...{ ...props }} />} 
            availableFilterOperations={[
              'equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'
            ]}
          />  
          <RowNumTypeProvider for={[ "row_num" ]} />                    
          <UidFlagsTypeProvider for={[ "uid_flags" ]} />
          <ProdDateTypeProvider for={[ "prod_date" ]} />
          
          <DateTypeProvider 
            for={[ 
              "first_update_date",
              "last_update_date"
            ]} 
          />
          <InstallUserTypeProvider for={[ "first_update_username" ]} />
          <LastUpdateUserTypeProvider for={[ "last_update_username" ]} />
          
          <GeoSimpleTypeProvider 
                      geoField="last_update_geo" 
                      for={[ "user_location" ]} />

          <DataTypeProvider for={[
              "total_petrol_time",
              "total_gas_time",
            ]}
            availableFilterOperations={[
              'equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual'
            ]}
          />
          <CalInfoTypeProvider for={[ "calibration_name" ]} />



          <SortingState
            sorting={this.state.tableSorting}
            onSortingChange={value => this.setState({ tableSorting: value })}
            columnExtensions={this.getTableSortingStateColumnExtensions()} />
          <VirtualTableState 
            loading={this.state.tableLoading}
            totalRowCount={this.state.tableTotalRowCount} 
            pageSize={VIRTUAL_PAGE_SIZE}
            skip={this.state.tableSkip}
            getRows={this.debouncedGetTableRows}
          />
          <FilteringState
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={this.getTableFilteringStateColumnExtensions()} />
          <VirtualTable 
            height={height}
            columnExtensions={this.getTableColumnExtensions()} />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={value => this.setState({ tableColumnWidths: value })} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow showFilterSelector />
        </Grid>
      </Paper>
    )
  }
}
